import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const ABOUT_IMG = "https://images.pexels.com/photos/34718931/pexels-photo-34718931.jpeg";

const About = () => {
  const { t } = useLang();

  return (
    <div data-testid="about-page">
      <Seo pageKey="about" />
      {/* HERO */}
      <section className="border-b border-white/10 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={ABOUT_IMG}
            alt="Industrial facility"
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/80 via-[#050505]/70 to-[#050505]" />
        </div>
        <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10 pt-20 lg:pt-28 pb-16 lg:pb-24">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-[#FF4500]" />
            <span className="text-overline text-[#FF4500]">{t.about.eyebrow}</span>
          </div>
          <h1
            data-testid="about-title"
            className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white max-w-5xl whitespace-pre-line"
          >
            {t.about.title}
          </h1>
          <p className="mt-8 text-white/75 max-w-3xl text-lg leading-relaxed">{t.about.lead}</p>
        </div>
      </section>

      {/* SECTIONS */}
      <section className="bg-[#050505]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {t.about.sections.map((s, i) => (
              <div
                key={s.t}
                data-testid={`about-section-${i}`}
                className="bg-[#0a0a0a] p-8 lg:p-10 hover:bg-[#0f0f0f] transition-colors"
              >
                <div className="font-display text-5xl text-[#FF4500] leading-none">
                  0{i + 1}
                </div>
                <h3 className="mt-6 font-display text-2xl uppercase text-white">{s.t}</h3>
                <p className="mt-4 text-white/70 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="border-t border-white/10 bg-[#0a0a0a]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {t.about.stats.map((s) => (
              <div key={s.l} className="bg-[#050505] p-8 text-center">
                <div className="font-display text-5xl lg:text-6xl text-white">{s.v}</div>
                <div className="text-overline text-[#FF4500] mt-3">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
